<template>
  <div class="login-container w-full min-h-screen flex flex-row flex-no-wrap justify-between items-center">
    <div class="login-form w-full sm:w-1/2 md:w-1/3 mx-auto">
      <div class="text-center text-5xl font-hairline">Welcome back, </div>
      <form class="px-8 pt-6 pb-12 mb-4" @submit.prevent>
        <div class="mb-4 mt-4">
          <input v-model="form.email" aria-label="email" class="h-12 appearance-none border-t w-full py-2 px-3 text-gray-700 leading-tight" id="email" type="text" placeholder="Email e.g john.doe@algo.com">
          <p v-if="error.includes('email')" class="email-error text-red-500 italic text-xs mt-2" data-testid="email-error">Please provide email</p>
        </div>
        <div class="mb-6">
          <input v-model="form.password" aria-label="password" class="h-12 appearance-none border-b w-full py-2 px-3 text-gray-700 mb-3 leading-tight" id="password" type="password" placeholder="* * * * * * *">
          <p v-if="error.includes('password')" class="email-password text-red-500 italic text-xs mt-2" data-testid="password-error">Please provide password</p>
        </div>
        <div class="flex items-center justify-between">
          <button class="bg-white hover:bg-gray-100 sm:w-1/2 md:w-1/2 lg:w-1/4 font-semibold py-2 px-4 border border-gray-400 rounded shadow text-blue-500" @click="login()">
            <span v-if="!processing">Sign In</span>
            <i v-else class="el-icon-processing"></i>
          </button>
          <router-link class="inline-block align-baseline font-thin text-sm italic text-blue-500 hover:text-blue-800" to="/auth/forget_password">
            Forgot Password?
          </router-link>
        </div>
      </form>
      <p class="text-center text-blue-500 text-xs">
        &copy;2020 ALGOSTACK AI. All rights reserved.
      </p>
    </div>

  </div>
</template>

<script>
import NotMerchantError from '../../Common/exceptions/NotMerchantError';
import PasswordResetNotDoneError from '../../Common/exceptions/PasswordResetNotDoneError';

export default {
  name: 'login',
  data() {
    return {
      form: {
        email: null,
        password: null,
      },

      error: [],
      processing: false,
    };
  },
  methods: {
    async login() {
      this.error = [];
      if (!this.form.email || this.form.email === '') {
        this.error.push('email');
      }

      if (!this.form.password || this.form.password === '') {
        this.error.push('password');
      }

      if (this.error.length === 0) {
        this.processing = true;
        try {
          await this.$store.dispatch('AuthStore/login', this.form);
          await this.$router.push('/dashboard/overview');
          this.$notify.success({
            title: 'Success',
            message: 'Successful Login',
          });
        } catch (e) {
          console.log(e);
          if (e instanceof NotMerchantError) {
            this.$notify.error({
              title: 'Error',
              message: 'You do not have permissions to access this platform.',
            });
          } else if (e instanceof PasswordResetNotDoneError) {
            await this.$router.push(`/auth/change_password?email=${this.form.email}`);
          } else {
            this.$notify.error({
              title: 'Error',
              message: 'Please contact the admin, something went wrong',
            });
          }
        }

        this.processing = false;
      }
    },
  },
};
</script>

<style scoped lang="scss">
  .login-container {
    background-image: url("../assets/images/funky-lines.png"), linear-gradient(to right bottom, #1d73b9, #257ac0, #2c81c8, #3388cf, #3a8fd7, #4395db, #4c9ce0, #54a2e4, #61a9e6, #6db0e8, #78b6e9, #84bdeb);
  }
  .login-form {

    flex: 0 1 100%;

    @media (min-width: 768px) {
      flex: 0 1 60%;
    }

    @media (min-width: 1000px) {
      flex: 0 1 40%;
    }

    input, button {
      border: 1px #ccc solid;
      border-radius: 5px;
      outline: none;
    }
  }
</style>
